export default "__VITE_ASSET__D0vaHg_G__"